// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Ca1W","requiredAsterisk":"Info_requiredAsterisk__2Ueh7"};